
const styles = {
    cardHead: {
        color: '#fff',
        textTransform: 'uppercase',
        lineHeight: '25px',
    },
    cardIcon: {
        color: '#fff', fontSize: '40px', textAlign: 'left', marginBottom: '40px'
    },
    featuresLink: {
        color: '#1f8bf3', fontSize: '14px', textDecoration: 'underline', color: '#fff', textDecoration: 'underline',
    },
    featuresPara: {
        color: '#fff', fontSize: '16px'
    }
}

export default styles;